import Layout from 'components/Layout';
import React, {useState} from 'react';
import styled from 'styled-components';
import {CategorySection} from './Money/CategorySection';
import {NoteSection} from './Money/NoteSection';
import {NumberPadSection} from './Money/NumberPadSection';
import {TagsSection} from './Money/TagsSection';
import {useRecords} from '../hooks/useRecord';

const MyLayout = styled(Layout)`
  display: flex;
  flex-direction: column;
`
const CategoryWrapper = styled.div`
  background: #c4c4c4;
`

type Category = '-' | '+'

const defaultFormData = {
  tagIds: [] as number[],
  note: '',
  category: '-' as Category,
  amount: 0
}

function Money() {
  const [selected, setSelected] = useState(defaultFormData)
  const {addRecord} = useRecords()
  // 点击 ok 触发 submit 函数 setRecord，Money 组件会再执行一遍 records 更新
  // Partial 部分类型
  const onChange = (obj: Partial<typeof selected>) => {
    setSelected({
      ...selected,
      ...obj
    })
  }

  const submit = () => {
    if (addRecord(selected)) {
      alert('保存成功')
      setSelected(defaultFormData)
    }
  }

  return (
    <MyLayout scrollTop={9999}>
      <TagsSection value={selected.tagIds}
        onChange={(tagIds) => onChange({tagIds}) }/>
      <NoteSection value={selected.note}
        onChange={(note) => onChange({note})}
      />
      <CategoryWrapper>
        <CategorySection value={selected.category}
                         onChange={(category) => onChange({category})}
        />
      </CategoryWrapper>
      <NumberPadSection value={selected.amount}
        onChange={(amount) => onChange({amount})}
        onOk={submit}
      />
    </MyLayout>
  );
}

export default Money;